export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[920px] flex-col gap-xl px-xl py-lg',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	userHeaderAvatar:
		'inline-flex h-[44px] w-[44px] shrink-0 items-center justify-center rounded-full border border-subtle bg-grey-25 text-[14px] font-semibold leading-none text-default',
	costCard: 'rounded-lg border border-subtle px-md py-sm text-right',
	sectionH: 'text-[15px] font-semibold leading-tight tracking-tight text-default',
	sectionSub: 'mt-3xs text-[12px] text-subtle',
	kvpLabel: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
	kvpValue: 'text-[13px] font-medium leading-tight text-default',
	turn: 'flex items-start gap-xs',
	turnAvatarUser:
		'inline-flex h-2xl w-2xl shrink-0 items-center justify-center rounded-full border border-subtle bg-grey-25 text-[11px] font-semibold leading-none text-default',
	turnAvatarAi:
		'inline-flex h-2xl w-2xl shrink-0 items-center justify-center rounded-full border border-purple-600 bg-purple-500 text-[11px] font-semibold leading-none text-white',
	turnAvatarSystem:
		'inline-flex h-2xl w-2xl shrink-0 items-center justify-center rounded-full border border-subtle bg-white text-subtle',
	bubble: 'rounded-lg px-md py-sm text-[13px] leading-relaxed text-default',
	bubbleUser: 'border border-subtle bg-grey-25',
	bubbleAi: 'border border-purple-100 bg-purple-25',
	bubbleSystem: 'italic text-[12px] text-subtle',
	bubbleTool: 'rounded-lg border border-subtle bg-white font-mono text-[12px]',
	metaRow: 'mb-2xs flex items-baseline gap-2xs text-[11px] leading-none text-subtle',
	badgeCost:
		'inline-flex items-center gap-3xs rounded-md border border-subtle bg-grey-25 px-2xs py-3xs font-mono text-[11px] font-medium leading-none text-subtle tabular-nums',
};
